import axios from 'axios';
import store from '@/store/store'
import router from "@/router";

const instance = axios.create();

// instance.defaults.baseURL = 'https://api.example.com';
// instance.defaults.baseURL = 'https://api.competency.mfu.ac.th';
// instance.defaults.baseURL = 'http://127.0.0.1:8082';
instance.defaults.baseURL = 'https://api-competency.mfu.ac.th/';
// instance.defaults.baseURL = 'https://apipre-competency.mfu.ac.th/';

// instance.defaults.timeout = 5000;


// เพิ่ม request interceptor
instance.interceptors.request.use(
    (config) => {
        const token = `${store.state.XAccessToken}`;
        if (token) {
            config.headers['X-Access-Token'] = `${store.state.XAccessToken}`;
        }
        config.headers["Content-Type"] = "application/json";
        config.headers.lang = `${store.getters['setting/lang']}`;
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// เพิ่ม Interceptor สำหรับ Response
instance.interceptors.response.use(
    (response) => {
        // คืนค่าปกติหาก response สำเร็จ
        return response;
    },
    (error) => {
        // ตรวจสอบสถานะ 401
        if (error.response && error.response.status === 401) {
            // แสดง Dialog หรือ Popup
            router.push('/login');
        }
        return Promise.reject(error);
    }
);


export default {

    Report_Method(method, data, configs) {
        switch (method) {
            case 'report_method':
                return instance.post("/api/v1/explore/report/method", data);
            default:
                break;
        }
    },

    Report_Assessment(method, data, configs) {
        switch (method) {
            case 'report_assessment':
                return instance.post("/api/v1/explore/report/assessment", data);
            default:
                break;
        }
    },

    idpReport(method, data, configs) {
        switch (method) {
            case 'explore':
                return instance.post("/api/v1/explore/report/idp", data);
            case 'status':
                return instance.post("/api/v1/explore/report/idp/status", data);
            case 'plans':
                return instance.post("/api/v1/explore/report/idp/plan", data);
            default:
                break;
        }
    },


}



